module.exports = __webpack_public_path__ + "img/result-img.f013f69c.png";